module.exports = __webpack_public_path__ + "img/outer_img.0bf02be6.png";